<template>
  <span class="str-wrap">
    <input
      v-show="inputElement && isUpdated"
      type="text"
      :value="value"
      @blur="handleUpdateInput"
      :maxLength="maxLength ? maxLength : ''"
      :class="{ err: err, 'is-view': inputElement }"
      :placeholder="placeholder"
    />

    <span>{{ value }}</span>
  </span>
</template>

<script>
export default {
  data() {
    return {
      isUpdated: true,
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
      required: false,
    },
    setKey: {
      type: String,
      default: '',
      required: false,
    },
    maxLength: {
      type: String,
      required: false,
      default: null,
    },
    inputElement: {
      type: Boolean,
      required: false,
      default: false,
    },
    err: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    handleUpdateInput(e) {
      this.isUpdated = false
      this.$emit('input-emit', { setKey: this.setKey, value: e.target.value })
      this.isUpdated = true
    },
  },
}
</script>

<style lang="scss" scoped>
.str-wrap {
  position: relative;
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  margin: -5px;
  display: flex;
  justify-content: space-between;

  span {
    padding: 2.5px;
  }

  > input {
    width: 100%;
    margin: 2.5px;
    padding: 5px;
  }

  > input.err {
    background-color: rgba(234, 85, 80, 0.5);
    border-radius: 2.5px;
    border: 1px solid #808080;
  }

  > input.is-view + span,
  > input.is-view + span ~ span {
    display: none;
  }
}

@media print {
  .str-wrap {
    input {
      display: none;
    }

    > input + span,
    > input + span ~ span {
      display: inline-flex !important;
      align-items: center;
      flex-wrap: wrap;
      padding: 0;
      justify-content: center;
      text-align: center;
      flex: none;
      width: 100%;
      margin: 2.5px;
    }
  }
}
</style>
